import React from "react";
import styles from "../../../assets/styles/Competition/Competition.module.scss";
import { MimaButton, MimaInput, MimaText, Modal } from "../../../components";
import { Formik } from "formik";

const CreateVotes = ({
  closeModal,
  onSubmit,
  validationSchema,
  loading,
  selectedParticipant,
}) => {
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" mb={4}>
        Create Votes
      </MimaText>
      <Formik
        initialValues={{
          votes: 0,
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <div>
            <MimaText
              labelTitle="Vote For"
              mb={2}
            >{`${selectedParticipant.firstname} ${selectedParticipant.lastname}`}</MimaText>
            <MimaText labelTitle="Competition" mb={2}>
              {selectedParticipant.competition.name}
            </MimaText>
            <MimaInput
              labelTitle="Votes"
              placeholder="Enter Votes"
              name="votes"
              type="number"
              value={values.votes}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.votes}
              touched={touched.votes}
            />
            <MimaButton
              title="Continue"
              mt={2}
              buttonColor="var(--color-dark-4)"
              onClick={handleSubmit}
              loading={loading}
              width={38}
            />
          </div>
        )}
      </Formik>
    </Modal>
  );
};
export default CreateVotes;
